<template>
  <div
    v-if="is_primary"
    v-tooltip="tooltip"
    class="flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium"
    :class="`${STATUS_COLORS[STATUS.PRIMARY].TAG_BG} ${STATUS_COLORS[STATUS.PRIMARY].TAG_TEXT} ${STATUS_COLORS[STATUS.PRIMARY].TAG_BORDER}`"
  >
    <FontAwesomeIcon
      :icon="['far', 'star']"
      class="h-2.5 w-2.5"
    />
    {{ label }}
  </div>

  <template v-else-if="!disabled">
    <button
      v-tooltip="tooltip"
      type="button"
      data-test="pill-toggle"
      class="flex items-center gap-1 rounded-full border bg-white py-1 pr-1 pl-3 text-xs font-medium transition-colors hover:border-gray-400 hover:bg-gray-100"
      :class="`${STATUS_COLORS[STATUS.PRIMARY].CARD_TEXT} ${STATUS_COLORS[STATUS.PRIMARY].TAG_BORDER}`"
      @click="popover.toggle($event)"
    >
      {{ label }}
      <span
        class="flex items-center rounded-full p-0.5 hover:bg-black/10"
        data-test="pill-remove"
        @click.stop="emit('remove')"
      >
        <FontAwesomeIcon
          :icon="['far', 'xmark']"
          class="h-2.5 w-2.5"
        />
      </span>
    </button>

    <Popover ref="popover">
      <div class="p-1">
        <button
          type="button"
          class="flex w-full items-center gap-2 rounded px-3 py-1.5 text-left text-sm font-medium text-gray-700 hover:bg-gray-100"
          data-test="pill-promote"
          @click="onPromote"
        >
          <FontAwesomeIcon
            :icon="['far', 'star']"
            class="h-3 w-3 text-gray-400"
          />
          {{ promote_label }}
        </button>
      </div>
    </Popover>
  </template>

  <div
    v-else
    v-tooltip="tooltip"
    class="flex items-center gap-1 rounded-full border bg-white px-3 py-1 text-xs font-medium"
    :class="`${STATUS_COLORS[STATUS.PRIMARY].CARD_TEXT} ${STATUS_COLORS[STATUS.PRIMARY].TAG_BORDER}`"
  >
    {{ label }}
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';

const props = defineProps({
  label: { type: String, required: true },
  promote_label: { type: String, required: true },
  tooltip: { type: String, default: null },
  is_primary: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['primary', 'remove']);

const popover = ref(null);

const onPromote = () => {
  if (!popover.value) return;
  popover.value.hide();
  emit('primary');
};
</script>
